/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Locale_HintInputs */

const cs_form_locale_hint = /** @type {(inputs: Form_Locale_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština je povinná. Ostatní jazyky jsou volitelné (Sreality: CS / EN / RU).`)
};

const en_form_locale_hint = /** @type {(inputs: Form_Locale_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czech is required. Other languages are optional (Sreality: CS / EN / RU).`)
};

/**
* | output |
* | --- |
* | "Czech is required. Other languages are optional (Sreality: CS / EN / RU)." |
*
* @param {Form_Locale_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_locale_hint = /** @type {((inputs?: Form_Locale_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Locale_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_locale_hint(inputs)
	return cs_form_locale_hint(inputs)
});